// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"72a72eb8","501":"651f8bbb","787":"bcc6fd91","806":"079397dd"}[chunkId] + ".chunk.js";
};